import {
    MapConstants,
    defaultGeoFeatureProperties,
} from '../constants/constants';

let map, Draw;

export const initMapActions = (mapInstance, drawInstance) => {
    map = mapInstance;
    Draw = drawInstance;
};

export const executeMapAction = (mapAction, cb) => {
    const {
        zoom,
        center,
        bounds,
        bearing,
        collection,
        draw,
        exportCollectionFromDraw,
        markerCollection,
        drawRoute,
        focus,
    } = mapAction;
    if (center) {
        const cameraOptions = {
            center,
            zoom: zoom || 15,
        };
        if (bearing !== undefined) {
            cameraOptions.bearing = bearing;
        }
        map.flyTo(cameraOptions);
    }
    if (bounds) {
        map.fitBounds(bounds, {
            padding: MapConstants.bboxPadding,
        });
    }
    if (collection && collection.features) {
        if (drawRoute) {
            if (collection.features.length) {
                clearCollection(MapConstants.id.source.geojsonFocus);
                clearCollection(MapConstants.id.source.geojsonPreview);
                setCollection(
                    MapConstants.id.source.geojsonRoutePreview,
                    collection,
                );
            } else {
                clearCollection(MapConstants.id.source.geojsonRoutePreview);
            }
        } else if (draw) {
            if (collection.features.length) {
                clearCollection(MapConstants.id.source.geojsonFocus);
                clearCollection(MapConstants.id.source.geojsonPreview);
                clearCollection(MapConstants.id.source.geojsonRoutePreview);
                Draw.set(collection);
            }
        } else if (focus) {
            setCollection(MapConstants.id.source.geojsonFocus, collection);
        } else if (collection.features.length) {
            if (collection.features.length) {
                clearCollection(MapConstants.id.source.geojsonFocus);
                clearCollection(MapConstants.id.source.geojsonRoutePreview);
                setCollection(MapConstants.id.source.geojsonPreview, collection);
                if (Draw) {
                    Draw.set(defaultGeoFeatureProperties.Collection);
                }
            }
        }
    }
    if (
        markerCollection &&
        markerCollection.features &&
        markerCollection.features.length
    ) {
        map.getSource(MapConstants.id.source.currentPositionMarker).setData(
            markerCollection,
        );
    }
    if (exportCollectionFromDraw) {
        const editedCollection = Draw.getAll();
        cb(editedCollection);
    }
};

const setCollection = (source, collection) => {
    if (map.getSource(source)) {
        map.getSource(source).setData(collection);
    } else {
        console.log(`Source ${source} not loaded`);
    }
};

const clearCollection = (source) => {
    if (map.getSource(source)) {
        map.getSource(source).setData(defaultGeoFeatureProperties.Collection);
    } else {
        console.log(`Source ${source} not loaded`);
    }
};
